// main.interceptor.ts
import { HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { includes } from 'lodash';

export const MainInterceptor = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  // Skip if the URL ends with or contains '*json'
  if (/[a-zA-Z\/\.-:0-9\-]*json/.test(req.url)) {
    return next(req);
  }

  const authToken = localStorage.getItem('elvkwdigttoken');
  const messageGroupId = localStorage.getItem('localMessageGroupId');
  const hasAuthHeader = req.headers.has('Authorization');

  const headers: Record<string, string> = {
    app: 'SIFCA',
    platform: 'web',
  };

  // Only attach our Authorization header if the request doesn't already provide one
  if (!hasAuthHeader && authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;

    const opName = req.body?.operationName;
    const isTargetedOp = includes(
      ['sendMessageToTarget', 'markAllMessageAsSeen', 'getMessagesByMemberPaginated'],
      opName
    );
    const messageGroup = req.body?.variables?.messageGroup || messageGroupId;

    if (isTargetedOp && messageGroup) {
      headers['messageGroupId'] = messageGroup;
    }
  }

  const modified = req.clone({ setHeaders: headers });
  return next(modified);
};
